import { render, staticRenderFns } from "./RightMenuItem.vue?vue&type=template&id=3fec5694&scoped=true"
import script from "./RightMenuItem.vue?vue&type=script&lang=js"
export * from "./RightMenuItem.vue?vue&type=script&lang=js"
import style0 from "./RightMenuItem.vue?vue&type=style&index=0&id=3fec5694&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fec5694",
  null
  
)

export default component.exports